import  { configureStore } from '@reduxjs/toolkit'
import Selector from '../Selectors/index.selector';


const newStore = configureStore({reducer: Selector })
export default newStore;